module.exports = "/assets/data/ce53c1ca6c27e3e2f78df402a5346f53-HS7.data.json";